import { cn } from '@/lib/utils/cn';

type SkeletonProps = {
  className?: string;
};

/** A calm, low-contrast placeholder. No shimmer — just a quiet pulse. */
export function Skeleton({ className }: SkeletonProps) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'animate-pulse rounded-md bg-ink-200/70 dark:bg-ink-800/70',
        className,
      )}
    />
  );
}
